module.exports = __webpack_public_path__ + "static/img/group.6b12e39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/temporary/group.jpg
// module id = gPts
// module chunks = 1